/**
 * 푸터. 예전에는 저작권 한 줄뿐이라 방침·문의로 가는 길이 상단 내비게이션에만 있었다 —
 * 페이지를 끝까지 읽고 내려온 사람에게 다음 행동이 없었다.
 *
 * **사업자 정보(상호·대표·등록번호)는 여기에 복사하지 않는다.** 값의 단일 출처는
 * `frontend/cottonray/web/src/content.ts` 의 `BUSINESS` 이고, 다른 파일로 복사하지 말라는 것이
 * `docs/rules.md` §서비스 구성의 규칙이다(한쪽만 고쳐지면 공개 사이트가 서로 다른 값을
 * 표시하게 된다). 그래서 회사 사이트로 링크만 건다.
 */
const LINKS = [
  { href: 'https://cottonray.com/privacy/easy-air-screen', label: 'Privacy' },
  { href: 'https://cottonray.com/support/easy-air-screen', label: 'Support' },
  { href: 'https://cottonray.com', label: 'Cottonray' },
] as const

export default function Footer() {
  return (
    <footer className="border-hair border-t">
      <div className="text-ink-mut mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-x-6 gap-y-3 px-5 py-8 text-sm sm:px-6">
        <p>© {new Date().getFullYear()} Cottonray</p>
        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2">
          {LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="hover:text-brand transition-colors"
              {...(link.href.startsWith('https://cottonray.com')
                ? { target: '_blank', rel: 'noopener noreferrer' }
                : {})}
            >
              {link.label}
            </a>
          ))}
        </nav>
      </div>
    </footer>
  )
}
